/**
 * Mini Oatmeal — "Notify me" waitlist (AJAX enhancement).
 *
 * Submits the Shopify customer form in the background so the success message
 * swaps in place (no reload, no scroll to the footer). Falls back gracefully:
 *   - Success            → Shopify redirects to ?customer_posted=true
 *   - Already subscribed → form re-renders with an "already/taken" message
 *   - Bot challenge      → Shopify redirects to /challenge; a captcha cannot be
 *                          solved via fetch, so we hand the browser off to it.
 *   - No JS / no fetch   → the form submits natively (server-rendered branch).
 *
 * Copy lives on the wrapper as data-success / data-exists / data-error so it
 * stays editable from the theme editor.
 */
(function () {
  function init() {
    var form = document.getElementById('MiniOatmealNotify');
    if (!form) return;

    var wrap = form.closest('[data-mini-notify]');
    if (!wrap) return;

    // After a captcha hand-off (or any native submit), Shopify reloads this page
    // with ?customer_posted=true and an anchor that scrolls down to the footer's
    // newsletter form. Pull the focus back to our success message and clean the URL
    // so the visitor lands here, not in the footer.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var landHere = function () {
        wrap.scrollIntoView({ block: 'center' });
      };
      // Strip the query + anchor first so any late hash-scroll has no target,
      // then assert our position now and again after assets finish loading
      // (the mascot GIF can delay the load event, when some browsers re-scroll).
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname);
      }
      landHere();
      window.requestAnimationFrame(landHere);
      window.setTimeout(landHere, 80);
      window.addEventListener('load', landHere);
    }

    // Guard against double-binding if the section is re-rendered in the editor.
    if (form.dataset.miniBound) return;
    form.dataset.miniBound = '1';

    function showMessage(text) {
      var p = document.createElement('p');
      p.className = 'mini-cs__notify-msg';
      p.setAttribute('role', 'status');
      p.textContent = text;
      wrap.replaceChildren(p);
    }

    form.addEventListener('submit', function (event) {
      // Progressive enhancement: let the form submit natively if fetch is absent.
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          var url = response.url || '';

          // Signed up successfully.
          if (url.indexOf('customer_posted=true') !== -1) {
            showMessage(wrap.dataset.success);
            return;
          }

          // Shopify bot/spam challenge — captcha can't be solved via fetch.
          // Send the browser to the challenge page; once solved, Shopify returns
          // to this page with ?customer_posted=true and the success shows.
          if (url.indexOf('/challenge') !== -1) {
            window.location.href = url;
            return;
          }

          // Re-rendered without a redirect: already-subscribed vs a real error.
          return response.text().then(function (html) {
            if (/already|taken/i.test(html)) {
              showMessage(wrap.dataset.exists);
            } else {
              showMessage(wrap.dataset.error);
              if (button) button.disabled = false;
            }
          });
        })
        .catch(function () {
          showMessage(wrap.dataset.error);
          if (button) button.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
